import React from 'react';

import {
	container as containerStyle,
	detail as detailStyle,
	heading as headingStyle,
} from './style.module.css';

interface CalloutItem {
	heading: string;
	detail: string;
}

export interface CalloutProps {
	items: Array<CalloutItem>;
}

export const Callout = ({ items }: CalloutProps) => {
	return (
		<div>
			{Array.isArray(items) &&
				items.map(({ heading, detail }, idx) => (
					<div className={containerStyle} key={`${heading}${idx}`}>
						<div className={headingStyle}>{heading}</div>
						<div className={detailStyle}>{detail}</div>
					</div>
				))}
		</div>
	);
};
